export default "__VITE_ASSET__BoUPQNaD__"